import { render, staticRenderFns } from "./TeacherResourceCard.vue?vue&type=template&id=703a06a6&scoped=true&"
import script from "./TeacherResourceCard.vue?vue&type=script&lang=js&"
export * from "./TeacherResourceCard.vue?vue&type=script&lang=js&"
import style0 from "./TeacherResourceCard.vue?vue&type=style&index=0&id=703a06a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703a06a6",
  null
  
)

export default component.exports